module.exports = __webpack_public_path__ + "static/media/3A.8638ec7c.jpg";